module.exports = __webpack_public_path__ + "img/crotchtokneelength.e51524a2.jpeg";